/*
  Product-card hover media.

  Two jobs:

  1. Hover images (snippets/product-card.liquid) ship with their URLs in
     data-src/data-srcset instead of src/srcset. They live at opacity:0 and
     are only ever revealed by :hover, so a touch device downloads a second
     full-size image per card and never shows a pixel of it. We promote the
     data-* attributes to the real ones ONLY on devices that report hover
     support - and on those, only once the browser is idle, so the fetch
     never competes with LCP. loading="lazy" stays on the element, so
     promoting still doesn't fetch cards that are far off screen.

  2. Hover videos keep their original play-on-enter / reset-on-leave
     behaviour, plus an eager promotion on first hover in case a shopper
     hovers a card before the idle pass has run.
*/
(function () {
  var canHover =
    !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function promote(img) {
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      delete img.dataset.srcset;
    }
    img.src = img.dataset.src;
    delete img.dataset.src;
  }

  function promoteCard(card) {
    var imgs = card.querySelectorAll('img.hover-image[data-src]');
    for (var i = 0; i < imgs.length; i++) promote(imgs[i]);
  }

  function promoteAll() {
    var imgs = document.querySelectorAll('img.hover-image[data-src]');
    for (var i = 0; i < imgs.length; i++) promote(imgs[i]);
  }

  if (canHover) {
    if (window.requestIdleCallback) {
      requestIdleCallback(promoteAll, { timeout: 3000 });
    } else {
      window.addEventListener('load', function () {
        setTimeout(promoteAll, 500);
      });
    }
  }

  function enteredCard(e) {
    var card = e.target.closest ? e.target.closest('.zivo-card') : null;
    if (!card) return null;
    var from = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.zivo-card') : null;
    return from === card ? null : card;
  }

  document.addEventListener('mouseover', function (e) {
    var card = enteredCard(e);
    if (!card) return;
    promoteCard(card);
    var video = card.querySelector('.hover-video');
    if (video) {
      video.setAttribute('preload', 'auto');
      video.play().catch(function () {});
    }
  });

  document.addEventListener('mouseout', function (e) {
    var card = enteredCard(e);
    if (!card) return;
    var video = card.querySelector('.hover-video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
})();
